import React, { useState } from "react";
import DataTable from "../../../../shared/components/DataTable";
import { Card, CardBody, Col } from "reactstrap";
import CustomSearch from "../../../Users/UsersList/components/CustomSearch";
import { dateTimeutils, dateFormats } from "../../../../utils/dateTimeUtils";
// import { MdReplay } from "react-icons/md";
import { reset } from 'redux-form';
import { connect } from "react-redux";

const DrawsTable = ({ retryDisbursement, dataSource, fetchData, dispatch }) => {
  const [searchKey, setSearchKey] = useState("");

  const capitalize = (s) => {
    if (typeof s !== "string") return s;
    return s.charAt(0).toUpperCase() + s.slice(1);
  };
  const columns = [
    {
      accessor: "winnerId",
      name: "Winner Id",
      filterable: true,
      sortable: false,
      sortKey: "winnerId",
      show: true,
    },
    {
      accessor: "winnerAmount",
      name: "Amount Won",
      filterable: true,
      sortable: true,
      sortKey: "winnerAmount",
    },
    {
      accessor: "winnerCreatedOn",
      name: "Disbursement Date",
      filterable: true,
      sortable: true,
      sortKey: "winnerCreatedOn",
      show: true,
      Cell: (row) => (
        <span>
          {dateTimeutils.formatDateTime(
            row.winnerCreatedOn,
            dateFormats.localFormatLong
          )}
        </span>
      ),
    },
    {
      accessor: "active",
      name: "Status (click to toggle)",
      sortable: true,
      sortKey: "active",
      renderHeader: () => <span>Status</span>,
      filterable: true,
      Cell: (row) => (
        <button
          type="button"
          id={`toggle-btn-${row.active ? "enabled" : "disabled"}-${row.id}`}
          onClick={() => {}}
          className={`btn ${
            row.winnerStatus && row.winnerStatus.includes("success")
              ? "btn-success"
              : row.winnerStatus && row.winnerStatus.includes("failed")
              ? "btn-danger"
              : "btn-info"
          } badge mb-0`}
        >
          <span>{row.winnerStatus && capitalize(row.winnerStatus)}</span>
        </button>
      ),
    },
    // {
    //   accessor: "",
    //   name: "",
    //   sortable: true,
    //   sortKey: "active",
    //   filterable: true,
    //   Cell: (row) => (
    //     <div>
    //       {row.winnerStatus && row.winnerStatus.includes("failed") ? (
    //         <span onClick={retryDisbursement}>
    //           <MdReplay /> Retry
    //         </span>
    //       ) : (
    //         ""
    //       )}
    //     </div>
    //   ),
    // },
  ];
  const sortFn = (pageNum, pageSize, column) => {
    let sortOrder = "ASC";
    if (!dataSource.loading) {
        if (dataSource.request && dataSource.request.sortOrder) {
            sortOrder = dataSource.request.sortOrder === "ASC" ? "DESC" : "ASC";
        }
        fetchData({
            ...dataSource.request,
            pageNum,
            pageSize,
            sortKey: column.sortKey,
            sortOrder,
        });
    }
};
const handleSubmit = (values) => {
    setSearchKey(values.searchWord);
    fetchData({
        ...dataSource.request,
        pageNum: 1,
        searchKey: values.searchWord || "",
    });
};
const clearForm = () => {
    dispatch(reset("custom_search"));
    setSearchKey("")
}
const loadData = (pageNum, pageSize) => {
    fetchData({
        ...dataSource.request,
        pageNum,
        pageSize,
        searchKey: searchKey,
    });
};

  
  return (
    <Col md={12} lg={12}>
      <Card>
        <CardBody>
          <DataTable
            columns={columns}
            data={
              dataSource.response?.content ||
              []
            }
            loading={dataSource.loading}
            countName="Winner(s)"
            count={dataSource.response?.count || null}
            clearSearch={clearForm}
            defaultPageSize={10}
            defaultPageNumber={1}
            bordered={true}
            striped={true}
            hover={true}
            loadData={loadData}
            responsive
            tableName="winners"
            customSearch={
              <CustomSearch
                pageNumer={1}
                initialValues={{
                  pageNumber: 1,
                  pageSize: 10,
                  searchKey: "",
                }}
                pageSize={10}
                onSubmit={handleSubmit}
                placeholder="Search by keyword (winner id...)"
              />
            }
            sortFn={sortFn}
            searchKey={searchKey}
            serverside
          />
        </CardBody>
      </Card>
    </Col>
  );
};


export default connect((state) => ({
  winnerDisbursement: state.winnerDisbursement
}))(DrawsTable);
